import React from "react";
import { Switch, Route } from "react-router-dom";
import { Home } from "../views/home/Home";
//询价单
import { Enquiry } from "../views/inquires/enquiry/view";
import { EnquiryDetails } from "../views/inquires/enquiry/view/details";
//报价单
import { Offer } from "../views/inquires/offer/view";
import { OfferDetails } from "../views/inquires/offer/view/details";
//外贸合同
import { Sales } from "../views/sales/view";
import { SalesDetails } from "../views/sales/view/details";
//采购合同
import { Purchases } from "../views/purchases/view";
import { PurchasesDetails } from "../views/purchases/view/details";
//出运管理
import { Shipment } from "../views/shipment/view";
import { ShipmentDetails } from "../views/shipment/view/details";
//外贸合同查询
import { SaleList } from "../views/ledger/saleList/view";
//采购合同查询
import { PurchaseList } from "../views/ledger/purchaseList/view";
//合同进程表
import { ProcessList } from "../views/ledger/processList/view";
import { AuditDetail } from "@/views/ledger/processList/view/DetailsBox";
//应收账款
import { Receivable } from "../views/ledger/receivable/view";
//应付账款
import { Payable } from "../views/ledger/payable/view";

//商品管理
import { BaseMaterial } from "../views/base/material/view";
import { BaseMaterialDetails } from "../views/base/material/view/DetailsBox";
//客户管理
import { BaseCustomer } from "../views/base/customer/view";
import { BaseCustomerDetails } from "../views/base/customer/view/DetailsBox";
//供应商管理
import { BaseSupplier } from "../views/base/supplier/view";
import { BaseSupplierDetails } from "../views/base/supplier/view/DetailsBox";
//仓库管理
import { BaseWarehouse } from "../views/base/warehouse/view";
import { BaseWarehouseDetails } from "../views/base/warehouse/view/details";
//数据字典
import { BaseDict } from "../views/base/dict/view";
import Error404 from "../views/404";
import { LatterOfCredit } from "@/views/warn/latterOfCredit/view";
import { CustomsDeclaration } from "@/views/warn/customsDeclaration/view";
import { ReceivableBill } from "@/views/warn/receivableBill/view";
import { PayableBill } from "@/views/warn/payableBill/view";
import { BusinessProcess } from "@/views/warn/businessProcess/view";
import { Certificate } from "@/views/warn/certificate/view";

import { Agreement } from "@/views/document/agreement/view";
import { ClassifiedSummary } from "@/views/document/classifiedSummary/view";
import { CustomsClearance } from "@/views/document/customsClearance/view";
import { RefundOfDuty } from "@/views/document/refundOfDuty/view";
import { Customs } from "@/views/document/customs/view";
import { Transport } from "@/views/document/transport/view";
import { ExportCreditCard } from "@/views/creditCard/export/view";
import { CceDetails } from "@/views/creditCard/export/view/details"
import { OfferSuccessStatistics } from "@/views/statistics/offerSuccess/view";
import { GrossProfitStatistics } from "@/views/statistics/grossProfit/view";
import { CustomerStatistics } from "@/views/statistics/customer/view";
import { TransportDetails } from "@/views/document/transport/view/details";
import { AgreementDetails } from "@/views/document/agreement/view/details";
import { ClassifiedSummaryDetails } from "@/views/document/classifiedSummary/view/details";
import { CustomsDetails } from "@/views/document/customs/view/details";
import { CustomsClearanceDetails } from "@/views/document/customsClearance/view/details";
import { RefundOfDutyDetails } from "@/views/document/refundOfDuty/view/details";

function AppRoute() {
    return (
        <Switch>
            <Route exact={true} path={"/"} key="1" component={Home} />

            <Route exact={true} path={"/inquires/enquiry"} key="2-1" component={Enquiry} />
            <Route exact={true} path={"/inquires/enquiry/add"} key="2-1-1" component={EnquiryDetails} />
            <Route exact={true} path={"/inquires/enquiry/edit"} key="2-1-2" component={EnquiryDetails} />

            <Route exact={true} path={"/inquires/offer"} key="2-2" component={Offer} />
            <Route exact={true} path={"/inquires/offer/add"} key="2-2-1" component={OfferDetails} />
            <Route exact={true} path={"/inquires/offer/edit"} key="2-2-2" component={OfferDetails} />

            <Route exact={true} path={"/sales"} key="3" component={Sales} />
            <Route exact={true} path={"/sales/add"} key="3-1" component={SalesDetails} />
            <Route exact={true} path={"/sales/edit"} key="3-2" component={SalesDetails} />

            <Route exact={true} path={"/purchases"} key="4" component={Purchases} />
            <Route exact={true} path={"/purchases/add"} key="4-1" component={PurchasesDetails} />
            <Route exact={true} path={"/purchases/edit"} key="4-2" component={PurchasesDetails} />

            <Route exact={true} path={"/shipment"} key="5" component={Shipment} />
            <Route exact={true} path={"/shipment/add"} key="5-1" component={ShipmentDetails} />
            <Route exact={true} path={"/shipment/edit"} key="5-2" component={ShipmentDetails} />

            <Route exact={true} path={"/ledger/processList"} key="6-1" component={ProcessList} />
            <Route exact={true} path={"/ledger/processList/detail"} key="6-1-1" component={AuditDetail} />
            <Route exact={true} path={"/ledger/payable"} key="6-2" component={Payable} />
            <Route exact={true} path={"/ledger/receivable"} key="6-3" component={Receivable} />
            <Route exact={true} path={"/ledger/saleList"} key="6-4" component={SaleList} />
            <Route exact={true} path={"/ledger/purchaseList"} key="6-5" component={PurchaseList} />

            <Route exact={true} path={"/base/material"} key="7-1" component={BaseMaterial} />
            <Route exact={true} path={"/base/material/add"} key="5-1-1" component={BaseMaterialDetails} />
            <Route exact={true} path={"/base/material/edit"} key="5-1-2" component={BaseMaterialDetails} />

            <Route exact={true} path={"/base/customer"} key="7-2" component={BaseCustomer} />
            <Route exact={true} path={"/base/customer/add"} key="7-2-1" component={BaseCustomerDetails} />
            <Route exact={true} path={"/base/customer/edit"} key="7-2-2" component={BaseCustomerDetails} />

            <Route exact={true} path={"/base/supplier"} key="7-3" component={BaseSupplier} />
            <Route exact={true} path={"/base/supplier/add"} key="7-3-1" component={BaseSupplierDetails} />
            <Route exact={true} path={"/base/supplier/edit"} key="7-3-2" component={BaseSupplierDetails} />

            <Route exact={true} path={"/base/warehouse"} key="7-4" component={BaseWarehouse} />
            <Route exact={true} path={"/base/warehouse/add"} key="7-4-1" component={BaseWarehouseDetails} />
            <Route exact={true} path={"/base/warehouse/edit"} key="7-4-2" component={BaseWarehouseDetails} />

            <Route exact={true} path={"/base/dict"} key="7-5" component={BaseDict} />

            {/* 单证管理 */}
            <Route exact={true} path={"/document/transport"} key="9-1" component={Transport} />
            <Route exact={true} path={"/document/transport/add"} key="9-1-1" component={TransportDetails} />
            <Route exact={true} path={"/document/transport/edit"} key="9-1-2" component={TransportDetails} />
            <Route exact={true} path={"/document/customs"} key="9-2" component={Customs} />
            <Route exact={true} path={"/document/customs/add"} key="9-2-1" component={CustomsDetails} />
            <Route exact={true} path={"/document/customs/edit"} key="9-2-2" component={CustomsDetails} />
            <Route exact={true} path={"/document/refundOfDuty"} key="9-3" component={RefundOfDuty} />
            <Route exact={true} path={"/document/refundOfDuty/add"} key="9-3-1" component={RefundOfDutyDetails} />
            <Route exact={true} path={"/document/refundOfDuty/edit"} key="9-3-2" component={RefundOfDutyDetails} />
            <Route exact={true} path={"/document/customsClearance"} key="9-4" component={CustomsClearance} />
            <Route exact={true} path={"/document/customsClearance/add"} key="9-4-1" component={CustomsClearanceDetails} />
            <Route exact={true} path={"/document/customsClearance/edit"} key="9-4-2" component={CustomsClearanceDetails} />
            <Route exact={true} path={"/document/classifiedSummary"} key="9-5" component={ClassifiedSummary} />
            <Route exact={true} path={"/document/classifiedSummary/add"} key="9-5-1" component={ClassifiedSummaryDetails} />
            <Route exact={true} path={"/document/classifiedSummary/edit"} key="9-5-2" component={ClassifiedSummaryDetails} />
            <Route exact={true} path={"/document/agreement"} key="9-6" component={Agreement} />
            <Route exact={true} path={"/document/agreement/add"} key="9-6-1" component={AgreementDetails} />
            <Route exact={true} path={"/document/agreement/edit"} key="9-6-2" component={AgreementDetails} />

            {/* 业务预警 */}
            <Route exact={true} path={"/warn/latterOfCredit"} key="8-1" component={LatterOfCredit} />
            <Route exact={true} path={"/warn/customsDeclaration"} key="8-2" component={CustomsDeclaration} />
            <Route exact={true} path={"/warn/receivableBill"} key="8-3" component={ReceivableBill} />
            <Route exact={true} path={"/warn/payableBill"} key="8-4" component={PayableBill} />
            <Route exact={true} path={"/warn/businessProcess"} key="8-6" component={BusinessProcess} />
            <Route exact={true} path={"/warn/certificate"} key="8-5" component={Certificate} />

            {/* 信用证管理 */}
            <Route exact={true} path={"/creditCard/export"} key="10-1" component={ExportCreditCard} />
            <Route exact={true} path={"/creditCard/export/add"} key="10-1-1" component={CceDetails} />
            <Route exact={true} path={"/creditCard/export/edit"} key="10-1-2" component={CceDetails} />

            {/* 统计分析 */}
            <Route exact={true} path={"/statistics/offerSuccess"} key="11-1" component={OfferSuccessStatistics} />
            <Route exact={true} path={"/statistics/grossProfit"} key="11-2" component={GrossProfitStatistics} />
            <Route exact={true} path={"/statistics/customer"} key="11-3" component={CustomerStatistics} />

            <Route exact={true} path={"/*"} key="404" component={Error404} />
        </Switch>
    )
}

export default AppRoute;